import {WidgetEventStruct} from '../../widget-event.struct';
import {DeviceWidgetEnum} from '../../../enums';

export class DeviceWidgetEventStruct extends WidgetEventStruct {
  public event_device_widget_type: DeviceWidgetEnum;
} // end Package
